module.exports = __webpack_public_path__ + "img/title6_5.bd79dfca.png";